<template>
  <OnboardingInfo @next="handleClick">
    <template #heading>
      <span class="text-gray-800">Active monitoring</span>
      <br />
      <span class="text-gray-400">across the internet.</span>
    </template>
    <template #body>
      <div>
        <DacrAIIcon
          class="inline h-[14px] align-[-1.3px]"
          aria-label="Dacr AI"
        />
        surfaces matches of your work.
        <div class="font-medium">Generate court-ready evidence in one tap.</div>
      </div>
    </template>
  </OnboardingInfo>
</template>

<script setup lang="ts">
import { DacrAIIcon } from '@dacr/icons'

import OnboardingInfo from '@/features/onboarding/components/OnboardingInfo.vue'
import { useCompleteStepMutation } from '@/shared/graphql/legacy/generated'
import { useOnboardingStore } from '@/features/onboarding/store'

const { mutate: completeStep } = useCompleteStepMutation()

const onboardingStore = useOnboardingStore()

const handleClick = () => {
  completeStep({ step: 8 })

  onboardingStore.goToNextStep()
}
</script>
